import {
  core_apimessages_Image,
  lp_APIImage,
} from './rql';

const TRANSFORMS = Object.freeze({
  thumb_small: 'c_fill,f_auto,g_center,h_96,w_96',
  thumb_large: 'c_fill,f_auto,g_center,h_450,w_450',
  original: 'c_limit,f_auto,h_1200,w_1200',
});

export function coreImageURLs(
  images: core_apimessages_Image[],
  transform: string,
  coreImageCdn: string,
): string[] {
  const transformString = TRANSFORMS[transform];
  const baseURL = `${coreImageCdn}/image/upload/${transformString}`;
  return images.map(({ publicId, version }) => {
    return `${baseURL}/v${version}/${publicId}.jpg`;
  });
}

export function lPImageURLs(
  keys: lp_APIImage[],
  transform: string,
  uploadImageCdn: string,
): string[] {
  return keys.map(({ key }) => {
    const transformString = TRANSFORMS[transform];
    return `${uploadImageCdn}/image/upload/${transformString}/v1/v2/images/${key}`;
  });
}
